import { useQuery } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";
const path = `${baseUrl}/committee_minute`;

export const {
  useGet: useGetCommitteeMinute,
  useGetAll: useAllCommitteeMinute,
} = apiCrudBuilder(path, "CommitteeMinute");

export const useCommitteeMinutePrint = (committeeMinuteId, options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["CommitteeMinute", committeeMinuteId, "print_view"],
    queryFn: () =>
      appAxios
        .get(`${path}/${committeeMinuteId}/print_view/`)
        .then((res) => res.data),
  });
};

export const useCommitteeMinutePreview = (dealFlowId, options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["CommitteeMinute", dealFlowId, "preview"],
    queryFn: () =>
      appAxios
        .get(`${path}/preview/`, { params: { deal_flow_id: dealFlowId } })
        .then((res) => res.data),
  });
};
